import { render, staticRenderFns } from "./OrderSubtotal.vue?vue&type=template&id=9b25760c&scoped=true&"
import script from "./OrderSubtotal.vue?vue&type=script&lang=js&"
export * from "./OrderSubtotal.vue?vue&type=script&lang=js&"
import style0 from "./OrderSubtotal.vue?vue&type=style&index=0&id=9b25760c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b25760c",
  null
  
)

export default component.exports